export const IS_DEMO = process.env.REACT_APP_DEMO_MODE === 'true';
